import { z } from "zod";

export const ChapterSchema = z.object({
  id: z.string(),
  title: z.string().min(1).max(100),
  startSeconds: z.number().finite().nonnegative(),
  endSeconds: z.number().finite().positive(),
  summary: z.string().optional(),
});
export type LessonChapter = z.infer<typeof ChapterSchema>;
export type ChapterInput = Pick<LessonChapter, "title" | "startSeconds" | "summary">;
export type ChapterReview = { draftId: string; chapters: ChapterInput[] };
